import { BasicModel } from './basic.model';

export class AnyLineModel {
  public action: string;
  public rightId: number;
  constructor(
    public id: number = null,
    public selected: any = new BasicModel(),
    public included: BasicModel[] = [],
    public excluded: BasicModel[] = [],
    public toRemove: BasicModel[] = [],
    public checked: boolean = false,
    public edited: boolean = false,
    public deleted: boolean = false,
    public created: boolean = false,
    public disabled: boolean = false,
    public lineSize: boolean = false,
    public hided: boolean = false,
    public excludedStr: string = null,
    public listExclSuggs: any[] = []
  ) {}

  public getAllIdExcluded(): number[] {
    return this.excluded.map(x => x.id);
  }

  public getAllIdIncluded(): number[] {
    return this.included.map(x => x.id);
  }

  public getAllRemoved(): number[] {
    return this.toRemove.map(x => x.id);
  }

  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
